import React, { useState, useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import Spinner from 'react-bootstrap/Spinner'
import Alert from 'react-bootstrap/Alert'
import { toast } from 'react-toastify'

import api from 'api/api'
import './galeria.css'
import Paginacion from 'components/Paginacion'

// Importar componentes
import NuevoGrupo from './NuevoGrupo'
import EditarGrupo from './EditarGrupo'
import DeleteGrupo from './DeleteGrupo'
import NuevaMultimedia from './NuevaMultimedia'
import EditarMultimedia from './EditarMultimedia'
import VerMultimedia from './VerMultimedia'
import DeleteMultimedia from './DeleteMultimedia'

function Galeria() {
	// Estados para grupos
	const [vista, setVista] = useState('grupos')
	const [grupoSeleccionado, setGrupoSeleccionado] = useState(null)
	const [grupos, setGrupos] = useState([])
	const [busquedaGrupo, setBusquedaGrupo] = useState('')
	const [filtroGrupo, setFiltroGrupo] = useState('')

	// Estados para multimedia
	const [multimedia, setMultimedia] = useState([])
	const [busquedaMultimedia, setBusquedaMultimedia] = useState('')
	const [filtroMultimedia, setFiltroMultimedia] = useState('')

	// Estados comunes
	const [fetchDeACuantos, setFetchDeACuantos] = useState(10)
	const [numResultados, setNumResultados] = useState(0)
	const [paginaAct, setPaginaAct] = useState(1)
	const [loading, setLoading] = useState(false)

	// Estados para modales/offcanvas
	const [actual, setActual] = useState(null)
	const [queMostrar, setQueMostrar] = useState('')

	// Efecto para búsqueda de grupos
	useEffect(() => {
		if (!loading) {
			const delayBusqueda = setTimeout(() => {
				setFiltroGrupo(busquedaGrupo)
			}, 400)
			return () => clearTimeout(delayBusqueda)
		}
	}, [busquedaGrupo])

	// Efecto para búsqueda de multimedia
	useEffect(() => {
		if (!loading && grupoSeleccionado) {
			const delayBusqueda = setTimeout(() => {
				setFiltroMultimedia(busquedaMultimedia)
			}, 400)
			return () => clearTimeout(delayBusqueda)
		}
	}, [busquedaMultimedia])

	// Efecto para refrescar grupos
	useEffect(() => {
		if (!loading) {
			refreshGrupos()
		}
	}, [filtroGrupo])

	// Efecto para refrescar multimedia
	useEffect(() => {
		if (!loading && vista === 'multimedia' && grupoSeleccionado) {
			if (paginaAct === 1) {
				refreshMultimedia()
			} else {
				setPaginaAct(1)
			}
		}
	}, [filtroMultimedia, fetchDeACuantos, vista, grupoSeleccionado])

	useEffect(() => {
		if (!loading && vista === 'multimedia' && grupoSeleccionado) {
			refreshMultimedia()
		}
	}, [paginaAct])

	const refreshGrupos = async () => {
		try {
			setLoading(true)
			const { datos } = await api.post('a/ver-galeria-grupos', {
				filtros: {
					nombre: [filtroGrupo]
				}
			})
			setGrupos(datos.grupos)
		} catch (error) {
			console.error(error)
			toast.error('Error al cargar grupos')
		} finally {
			setLoading(false)
		}
	}

	const refreshMultimedia = async () => {
		if (!grupoSeleccionado) return

		try {
			setLoading(true)
			const { datos } = await api.post('a/ver-galeria-multimedia', {
				grupoId: grupoSeleccionado.id,
				cuantos: fetchDeACuantos,
				desde: paginaAct === 1 ? 0 : (paginaAct - 1) * fetchDeACuantos,
				filtros: {
					descripcion: [filtroMultimedia]
				}
			})
			setMultimedia(datos.multimedia)
			setNumResultados(datos.numResultados)
		} catch (error) {
			console.error(error)
			toast.error('Error al cargar multimedia')
		} finally {
			setLoading(false)
		}
	}

	// Manejadores CRUD grupos
	const guardarGrupo = async (data) => {
		setLoading(true)
		try {
			if (data.id) {
				const { msg } = await api.put(`a/galeria/grupos/${data.id}`, data)
				toast.success(msg)
			} else {
				const { msg } = await api.post('a/galeria/grupos', data)
				toast.success(msg)
			}
			refreshGrupos()
			setQueMostrar('')
		} catch (error) {
			console.error(error)
			toast.error('Error al guardar grupo')
		} finally {
			setLoading(false)
		}
	}

	const eliminarGrupo = async (id) => {
		try {
			const { msg } = await api.delete(`a/galeria/grupos/${id}`)
			refreshGrupos()
			setQueMostrar('')
			toast.success(msg)
			if (grupoSeleccionado?.id === id) {
				setGrupoSeleccionado(null)
				setVista('grupos')
			}
		} catch (error) {
			console.error(error)
			toast.error('Error al eliminar grupo')
		}
	}

	const guardarMultimedia = async (data) => {
		setLoading(true)
		try {
			if (data.id) {
				// Estamos editando
				const actualizaciones = {
					id: data.id
				}

				// Si hay nueva imagen
				if (data.files && data.files.length > 0) {
					const formData = new FormData()
					formData.append('foto', data.files[0])
					const { datos: respuesta } = await api.post('a/multimedia', formData, {
						headers: { 'Content-Type': 'multipart/form-data' }
					})
					actualizaciones.nuevoMultimediaId = respuesta.id
				}

				// Si hay cambios en la descripción
				if (data.descripcion !== undefined) {
					actualizaciones.descripcion = data.descripcion
				}

				// Si hay cambios en el orden
				if (data.orden !== undefined) {
					actualizaciones.orden = data.orden
				}

				if (Object.keys(actualizaciones).length > 1) {
					const { msg } = await api.put(
						`a/galeria/grupos/${grupoSeleccionado.id}/multimedia/${data.id}`,
						actualizaciones
					)
					toast.success(msg)
				}
			} else {
				// Estamos creando nuevo
				const formData = new FormData()
				formData.append('foto', data.files[0])
				formData.append('descripcion', data.descripcion)

				// Primero subimos el archivo
				const { datos: respuesta } = await api.post('a/multimedia', formData, {
					headers: { 'Content-Type': 'multipart/form-data' }
				})

				// Luego lo asociamos al grupo
				const datosMultimedia = {
					multimediaId: respuesta.id,
					orden: data.orden
				}
				const { msg } = await api.post(
					`a/galeria/grupos/${grupoSeleccionado.id}/multimedia`,
					datosMultimedia
				)
				toast.success(msg)
			}

			await refreshMultimedia()
			// Actualizamos el conteo localmente
			if (!data.id) { // Si es nuevo
				setGrupos(prev => prev.map(g =>
					g.id === grupoSeleccionado.id
						? { ...g, multimedia: [...(g.multimedia || []), {}] }
						: g
				))
			}

			setQueMostrar('')
		} catch (error) {
			console.error(error)
			toast.error('Error al guardar multimedia')
		} finally {
			setLoading(false)
		}
	}

	const eliminarMultimedia = async (id) => {
		try {
			const { msg } = await api.delete(`a/multimedia/${id}`)
			
			await refreshMultimedia()

			// Actualizamos el conteo localmente
			setGrupos(prev => prev.map(g =>
				g.id === grupoSeleccionado.id
					? { ...g, multimedia: (g.multimedia || []).filter(m => m.id !== id) }
					: g
			))
			setQueMostrar('')
			toast.success(msg)
		} catch (error) {
			console.error(error)
			toast.error('Error al eliminar multimedia')
		}
	}

	return (
		<Container fluid id="galeria" className="vh-100">
			{/* Barra de navegación superior */}
			<Row className="mb-3 align-items-center">
				<Col>
					{vista === 'multimedia' && (
						<Button
							variant="outline-secondary"
							onClick={() => {
								setVista('grupos')
								setGrupoSeleccionado(null)
							}}
							className="me-2"
						>
							<i className="fa fa-arrow-left"></i> Volver a grupos
						</Button>
					)}
					<span className="h4 mb-0">
						{vista === 'grupos' ? 'Grupos de Galería' : `Multimedia - ${grupoSeleccionado?.nombre}`}
					</span>
				</Col>
			</Row>

			{/* Vista de Grupos */}
			{vista === 'grupos' && (
				<Row>
					<Col>
						<Row className="mb-3 justify-content-between">
							<Col md={4}>
								<Form.Group controlId="txtBusquedaGrupo">
									<InputGroup>
										<Form.Control
											value={busquedaGrupo}
											onChange={(e) => setBusquedaGrupo(e.target.value)}
											placeholder="Buscar grupo..."
										/>
										<InputGroup.Text>
											<i className="fa fa-search"></i>
										</InputGroup.Text>
									</InputGroup>
								</Form.Group>
							</Col>
							<Col className="text-end">
								<Button onClick={() => setQueMostrar('nuevo-grupo')} variant="primary">
									<i className="fa fa-plus"></i> Nuevo grupo
								</Button>
							</Col>
						</Row>

						<Table bordered hover>
							<thead>
								<tr>
									<th>ID</th>
									<th>Nombre</th>
									<th>Orden</th>
									<th>Número de archivos</th>
									<th>Acciones</th>
								</tr>
							</thead>
							<tbody>
								{loading ? (
									<tr>
										<td colSpan="5" className="text-center">
											<Spinner animation="border" variant="primary" />
										</td>
									</tr>
								) : grupos.length === 0 ? (
									<tr>
										<td colSpan="5">
											<Alert variant="info">No se encontraron grupos</Alert>
										</td>
									</tr>
								) : (
									grupos.map(grupo => (
										<tr key={grupo.id}>
											<td>{grupo.id}</td>
											<td>{grupo.nombre}</td>
											<td>{grupo.orden}</td>
											<td>{grupo.multimedia.length || 0}</td>
											<td>
												<Button
													onClick={() => {
														setGrupoSeleccionado(grupo)
														setVista('multimedia')
													}}
													className="me-2"
													variant="primary"
												>
													<i className="fa fa-images"></i> Ver multimedia
												</Button>
												<Button
													onClick={() => {
														setActual(grupo)
														setQueMostrar('editar-grupo')
													}}
													className="me-2"
													variant="secondary"
												>
													<i className="fa fa-pencil"></i>
												</Button>
												<Button
													onClick={() => {
														setActual(grupo)
														setQueMostrar('eliminar-grupo')
													}}
													variant="danger"
												>
													<i className="fa fa-trash"></i>
												</Button>
											</td>
										</tr>
									))
								)}
							</tbody>
						</Table>
					</Col>
				</Row>
			)}

			{/* Vista de Multimedia */}
			{vista === 'multimedia' && grupoSeleccionado && (
				<Row>
					<Col>
						<Row className="mb-3 justify-content-between align-items-center">
							<Col sm={6} md={3}>
								<Form.Select
									size="sm"
									onChange={(e) => setFetchDeACuantos(e.target.value)}
									value={fetchDeACuantos}
								>
									{[10, 25, 50].map(o => (
										<option key={o} value={o}>{o} por página</option>
									))}
								</Form.Select>
							</Col>
							<Col md={4}>
								<Form.Group controlId="txtBusquedaMultimedia">
									<InputGroup>
										<Form.Control
											value={busquedaMultimedia}
											onChange={(e) => setBusquedaMultimedia(e.target.value)}
											placeholder="Buscar multimedia..."
										/>
										<InputGroup.Text>
											<i className="fa fa-search"></i>
										</InputGroup.Text>
									</InputGroup>
								</Form.Group>
							</Col>
							<Col className="text-end">
								<Button onClick={() => setQueMostrar('nueva-multimedia')} variant="primary">
									<i className="fa fa-plus"></i> Nueva imagen
								</Button>
							</Col>
						</Row>

						<Table bordered hover>
							<thead>
								<tr>
									<th>ID</th>
									<th>Imagen</th>
									<th>Descripción</th>
									<th>Orden</th>
									<th>Acciones</th>
								</tr>
							</thead>
							<tbody>
								{loading ? (
									<tr>
										<td colSpan="5" className="text-center">
											<Spinner animation="border" variant="primary" />
										</td>
									</tr>
								) : multimedia.length === 0 ? (
									<tr>
										<td colSpan="5">
											<Alert variant="info">No se encontraron archivos multimedia</Alert>
										</td>
									</tr>
								) : (
									multimedia.map(item => (
										<tr key={item.id} style={{ verticalAlign: 'middle' }}>
											<td>{item.id}</td>
											<td style={{ width: '80px' }}>
												<img
													src={process.env.REACT_APP_API_URL + 'uploads/' + item.url}
													alt={item.descripcion}
													className="img-fluid"
												/>
											</td>
											<td>{item.descripcion}</td>
											<td>{item.orden}</td>
											<td>
												<Button
													onClick={() => {
														setActual(item)
														setQueMostrar('ver-multimedia')
													}}
													className="me-2"
													variant="primary"
												>
													<i className="fa fa-eye"></i>
												</Button>
												<Button
													onClick={() => {
														setActual(item)
														setQueMostrar('editar-multimedia')
													}}
													className="me-2"
													variant="secondary"
												>
													<i className="fa fa-pencil"></i>
												</Button>
												<Button
													onClick={() => {
														setActual(item)
														setQueMostrar('eliminar-multimedia')
													}}
													variant="danger"
												>
													<i className="fa fa-trash"></i>
												</Button>
											</td>
										</tr>
									))
								)}
							</tbody>
						</Table>

						{/* Paginación */}
						{multimedia.length > 0 && (
							<Row>
								<Col>
									<Paginacion
										pagina={paginaAct}
										numPaginas={Math.ceil(numResultados / fetchDeACuantos) || 1}
										setPagina={setPaginaAct}
									/>
								</Col>
							</Row>
						)}
					</Col>
				</Row>
			)}

			{/* Modales y Paneles Grupos */}
			{queMostrar === 'nuevo-grupo' && (
				<NuevoGrupo
					guardar={guardarGrupo}
					setQueMostrar={setQueMostrar}
				/>
			)}

			{actual && queMostrar === 'editar-grupo' && (
				<EditarGrupo
					grupo={actual}
					setQueMostrar={setQueMostrar}
					guardar={guardarGrupo}
				/>
			)}

			{actual && queMostrar === 'eliminar-grupo' && (
				<DeleteGrupo
					grupo={actual}
					mostrar={true}
					setQueMostrar={setQueMostrar}
					eliminarGrupo={eliminarGrupo}
				/>
			)}

			{/* Modales y Paneles Multimedia */}
			{queMostrar === 'nueva-multimedia' && (
				<NuevaMultimedia
					grupo={grupoSeleccionado}
					guardar={guardarMultimedia}
					setQueMostrar={setQueMostrar}
				/>
			)}

			{actual && queMostrar === 'ver-multimedia' && (
				<VerMultimedia
					multimedia={actual}
					setQueMostrar={setQueMostrar}
				/>
			)}

			{actual && queMostrar === 'editar-multimedia' && (
				<EditarMultimedia
					multimedia={actual}
					setQueMostrar={setQueMostrar}
					guardar={guardarMultimedia}
				/>
			)}

			{actual && queMostrar === 'eliminar-multimedia' && (
				<DeleteMultimedia
					multimedia={actual}
					mostrar={true}
					setQueMostrar={setQueMostrar}
					eliminarMultimedia={eliminarMultimedia}
				/>
			)}
		</Container>
	)
}

export default Galeria